import React, { useEffect } from "react";
import bio50 from "./images/50bio.png";
import abm from "./images/abm.png";
import um from "./images/um.jpg";
import neoVinci from "./images/logo_neo.svg";
import headerImg from "./images/header.png";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
} from "@mui/material";
import { Link } from "react-router-dom";
import { ROUTES_CORE } from "commons/constants/paths";
import {
  StyledNavbarList,
  StyledNavbarListItem,
  StyledLoginButton,
  StyledFooter,
  StyledFooterDescription,
  StyledFooterSection,
  StyledFooterImg,
  StyledFooterImgSpan,
  StyledHeaderHolder,
  StyledHeaderImg,
  StyledHeaderSection,
  StyledHeaderSubtitle,
  StyledHeaderTitle,
  StyledAnchor,
  StyledContactWayTitle, StyledFooterAnchor,
  StyledFooterMenu,
  StyledFooterMenuLink,
  StyledFooterTitle
} from "./Home.styled";
import { useAppDispatch } from "commons/store/hooks";
import MedicalCenter from "../components/MedicalCenter";
import {
  PROJECT_NAME,
  PROJECT_TECHNICAL_EMAIL,
  PROJECT_TECHNICAL_PHONE
} from "commons/constants/env";

function Home() {
  const dispatch = useAppDispatch();

  /** Tab title controller */
  useEffect(() => {
    document.title = `${PROJECT_NAME} - Strona Główna`;
    return () => {
      document.title = PROJECT_NAME;
    };
  }, [dispatch]);

  return (
    <div>
      <header>
        <Container maxWidth="lg">
          <Grid container spacing={0} direction="row" justifyContent="space-between" alignItems="center" style={{ minHeight: '70px' }}>
            <Grid container item lg={3} xs={12} spacing={0}>
              {/* <StyledLogo src={imprv} alt="Projekt logo" /> */}
            </Grid>
            <Grid container item lg={9} xs={12} spacing={0}>
              <StyledNavbarList>
                <StyledNavbarListItem>
                  <StyledLoginButton
                    variant="contained"
                    color="primary"
                    to={ROUTES_CORE.LOGIN}
                    component={Link}
                  >
                    SIGN IN
                  </StyledLoginButton>
                </StyledNavbarListItem>
              </StyledNavbarList>
            </Grid>
          </Grid>
        </Container>
      </header>

      <StyledHeaderSection>
        <StyledHeaderImg src={headerImg} alt="Background img"/>
        <StyledHeaderHolder>
          <Container maxWidth="lg">
            <StyledHeaderTitle>
              <b>EKSPERYMENT AIDA</b>
            </StyledHeaderTitle>
            <StyledHeaderSubtitle>
              Prospektywne, randomizowane wieloośrodkowe badanie III fazy typu non-inferiority oceniające skuteczność
              i bezpieczeństwo aktywnej obserwacji w porównaniu do podtrzymywania lenalidomidem po leczeniu pierwszej
              linii schematem DVTd (daratumumab, bortezomib, talidomid, deksametazon) oraz ASCT u pacjentów
              z co najmniej VGPR i ujemną mierzalną chorobą resztkową (MRD) – AIDA
            </StyledHeaderSubtitle>
          </Container>
        </StyledHeaderHolder>
      </StyledHeaderSection>

      <section>
        <Container maxWidth="lg">
          <MedicalCenter />
        </Container>
      </section>

      <StyledFooter>
        <Container maxWidth="lg">
          <StyledFooterSection>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <StyledFooterTitle>Kontakt w sprawach technicznych:</StyledFooterTitle>
                <StyledContactWayTitle>e-mail: </StyledContactWayTitle>
                <StyledAnchor href={`mailto:${PROJECT_TECHNICAL_EMAIL}`}>
                  {PROJECT_TECHNICAL_EMAIL}
                </StyledAnchor>
                <br/>
                <StyledContactWayTitle>telefon: </StyledContactWayTitle>
                <StyledFooterAnchor href={`tel:${PROJECT_TECHNICAL_PHONE}`}>
                  {PROJECT_TECHNICAL_PHONE}
                </StyledFooterAnchor>
              </Grid>
              <Grid item xs={12} md={6}>
                <StyledFooterTitle>Logowanie do eCRF:</StyledFooterTitle>
                <Box>
                  <StyledLoginButton
                    color="primary"
                    variant="contained"
                    to={ROUTES_CORE.LOGIN}
                    component={Link}
                  >
                    LOGOWANIE
                  </StyledLoginButton>
                </Box>
              </Grid>
            </Grid>
          </StyledFooterSection>
          <StyledFooterSection>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12}>
                <StyledFooterTitle>INFORMACJE O BADANIU:</StyledFooterTitle>
                <StyledContactWayTitle><b>Główny badacz: </b>Prof. dr hab. Tomasz Wróbel</StyledContactWayTitle><br/>
                <StyledContactWayTitle><b>Wartość projektu:</b>13 625 011,40 zł</StyledContactWayTitle><br/>
                <StyledContactWayTitle><b>Wartość dofinansowania:</b>13 625 011,40 zł</StyledContactWayTitle><br/>
                <StyledContactWayTitle><b>Okres realizacji projektu: </b>2023-08-01 – 2029-07-31</StyledContactWayTitle><br/>
                <StyledContactWayTitle>
                  <b>Źródło finansowania: </b>
                  Badanie finansowane ze środków budżetu państwa od Agencji Badań Medycznych,
                  numer Projektu 2023/ABM/01/000018
                </StyledContactWayTitle>
              </Grid>
            </Grid>
          </StyledFooterSection>
          <StyledFooterSection>
            <Grid container spacing={3} justifyContent="center">
              <Grid item xs={12} sm={6} md={4} lg={2}>
                <StyledFooterImgSpan>Kontaktowa organizacja badawcza (CRO):</StyledFooterImgSpan>
                <StyledFooterImg src={bio50} alt="50Bio logo"/>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={2}>
                <StyledFooterImg src={um} alt="UM logo"/>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={2}>
                <StyledFooterImg src={abm} alt="ABM logo"/>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={2}>
                <StyledFooterImgSpan>Technical organizator:</StyledFooterImgSpan>
                <StyledFooterImg src={neoVinci} alt="Neo-Vinci logo"/>
              </Grid>
            </Grid>
          </StyledFooterSection>
        </Container>
      </StyledFooter>
    </div>
  );
}

export default Home;
